import gql from 'graphql-tag';

export const Auth = gql`
  fragment Auth on Auth {
    refreshToken
    idToken
  }
`;
